

































































































import { mapActions, mapGetters, mapState } from 'vuex';
import LoaderInline from '@/components/LoaderInline.vue';
import quotes from './quotes';

export default {
  mounted() {
    this.getRandomQuote();
  },
  data: () => ({
    quote: '',
    search: '',
  }),
  computed: {
    ...mapGetters('search', [
      'isSearchLoading',
    ]),
    ...mapState('search', [
      'history',
      'result',
      'page',
    ]),
    currentlySearched() {
      // display the message for nor esults found
      // only when current search term equals search query
      const currentlySearched = this.searchValue === this.page.query.value;
      return !this.isSearchLoading && currentlySearched;
    },
    searchValue: {
      get() {
        return this.search;
      },
      set(value: string = '') {
        this.search = value;
        this.request({
          // set to page 1 of results
          number: 1,
          query: {
            value,
          },
        });
      },
    },
  },
  watch: {
    result() {
      this.getRandomQuote();
    },
  },
  methods: {
    ...mapActions('chrome', [
      'showStack',
    ]),
    ...mapActions('search', [
      'addToHistory',
      'clearSearch',
      'request',
    ]),
    focus(event: KeyboardEvent, next: boolean) {
      const target = event.target as HTMLDivElement;
      const nextElement = next
        ? target.nextElementSibling
        : target.previousElementSibling;
      if (nextElement) {
        (nextElement as HTMLDivElement).focus();
        this.preventScroll(event);
      } else if (next === false) {
        this.focusOnFilter();
      }
    },
    focusOnFilter() {
      const filterInput = this.$refs.filterInput;
      filterInput
        && (filterInput as HTMLDivElement).focus();
    },
    focusOnFirstItem(event: KeyboardEvent) {
      const ref = this.$refs['option-0'];
      if (Array.isArray(ref) && ref[0]) {
        (ref[0].$el as HTMLElement).focus();
        this.preventScroll(event);
      }
    },
    getRandomQuote() {
      this.quote = quotes[Math.floor(quotes.length * Math.random())];
    },
    preventScroll({ view }: KeyboardEvent) {
      // prevent scroll
      view
        && view.event
        && view.event.preventDefault();
    },
    selectResult(item: any) {
      const isCurrentPage = this.$route.params[`${item.type}Id`] === item.id;
      isCurrentPage && this.showStack(0);
      this.addToHistory(this.search);
    },
  },
  components: {
    LoaderInline,
  },
} as IView;
